import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import "./DatacenterList.less";
import { Checkbox, Input, ListItemText, Tooltip } from "@material-ui/core";
import { removeDuplicates } from "../../../utils/helper";
import { ShowToast, toastType } from "../../../utils/toast-service";

class DatacenterList extends React.Component {
  constructor(props) {
    super(props);
    const ignoreLocalStorage = props.ignoreLocalStorage
      ? props.ignoreLocalStorage
      : false;
    this.state = {
      selectedPropertyId:
        localStorage.getItem("selectedPropertyId") != null &&
        !ignoreLocalStorage
          ? localStorage.getItem("selectedPropertyId")
          : 0,
      selectedPropertyIdMultiple:
        localStorage.getItem("selectedPropertyIdMultipleNames") != undefined &&
        !ignoreLocalStorage
          ? (
              localStorage.getItem("selectedPropertyIdMultipleNames") || ""
            ).split(",")
          : ["All"],
      selectedIDSet:
        localStorage.getItem("selectedPropertyIdMultiple") != null &&
        !ignoreLocalStorage
          ? localStorage
              .getItem("selectedPropertyIdMultiple")
              .split(",")
              .map(function(item) {
                return parseInt(item, 10);
              })
          : [0],
      selectAll: ignoreLocalStorage,
      selectedPropertyAbbr:
        localStorage.getItem("Abbreviation") != null && !ignoreLocalStorage
          ? localStorage.getItem("Abbreviation").split(",")
          : [],
      ignoreLocalStorage: false
    };
  }

  /**
   * on load call with new props
   * @param {*} newProps 
   */
  componentWillReceiveProps(newProps) {
    if (newProps.isChangedDC !== this.props.isChangedDC) {
      const nameList = [];
      const AbbrList = [];

      (newProps.selectedPropertyId.split(",") || []).map(value => {
        const data = (this.props.dataSource || []).filter(
          x => x.propertyID == value
        );
        nameList.push((data[0] || {}).name || "All");
        AbbrList.push((data[0] || {}).abbreviation || "");
      });

      this.setState({
        selectedIDSet: newProps.selectedPropertyId.split(","),
        selectedPropertyAbbr: AbbrList,
        selectedPropertyIdMultiple: nameList,
        selectAll: newProps.dataSource.length === nameList.length
      });
    }
    if (newProps.selectedPropertyId !== this.props.selectedPropertyId) {
      if (newProps.selectedPropertyId.length >= 1) {
        this.setState({ selectedPropertyId: newProps.selectedPropertyId });
      }
    }
    if (
      !this.props.dataSource &&
      newProps.dataSource &&
      newProps.dataSource.length
    ) {
      if (
        newProps.dataSource.length ==
        this.state.selectedPropertyIdMultiple.length
      ) {
        this.setState({ selectAll: true });
      }
    }
  }

  /**
   * set single select dropdown value
   * @param {*} DcID 
   */
  setSingleSelect = DcID => {
    this.props.onPropertySelect(DcID);
    this.setState({ selectedPropertyId: DcID });
  };

  /**
   * call on data center dropdown change
   * @param {*} values 
   * @returns 
   */
  handleOnDataCenterChange = values => {
    if (values.length < 1) {
      ShowToast(
        "At least one data center has to be selected",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }

    let ArrayOfValues = {};

    if (values.find(x => x == "All") == "All") {
      ArrayOfValues = this.props.dataSource.map(change => change.name);
      //console.log(typeof values, values, typeof ArrayOfValues, ArrayOfValues);
    } else {
      ArrayOfValues = values.map(change => change);
      // console.log(typeof values, values, typeof ArrayOfValues, ArrayOfValues);
    }

    if (!this.state.ignoreLocalStorage) {
      localStorage.setItem("selectedPropertyIdMultipleNames", []);
      localStorage.setItem("selectedPropertyIdMultipleNames", ArrayOfValues);
    }
    const ComparisonData = this.props.dataSource;
    let IdSetArray;
    let Abbr;
    let NewSet = [];
    if (values == "All" || values[values.length - 1] == "All") {
      if (this.state.selectAll == true) {
        const DCDetails = this.props.dataSource.filter(
          x => x.name == values[0]
        );
        //console.log(DCDetails);
        ShowToast(
          "You cannot deselect all the Data Centers, hence default Data Center is selected.",
          toastType.WARNING,
          5000,
          null
        );

        this.setState(
          {
            selectedPropertyIdMultiple: [DCDetails[0].name],
            selectedIDSet: [DCDetails[0].propertyID],
            selectedPropertyAbbr: [DCDetails[0].abbreviation],
            selectAll: false
          },
          () => {
            localStorage.setItem("selectedPropertyIdMultipleNames", [
              DCDetails[0].name
            ]);
            localStorage.setItem("selectedPropertyIdMultiple", [
              DCDetails[0].propertyID
            ]);
            localStorage.setItem("Abbreviation", [DCDetails[0].abbreviation]);
          }
        );
      } else {
        IdSetArray = ComparisonData.map(values => values.propertyID);
        NewSet = ComparisonData.map(values => values.name);
        Abbr = ComparisonData.map(values => values.abbreviation);
        values = NewSet;
        // console.log(values, IdSetArray);
        if (values.find(x => x == "All") != "All") {
          const Abbr1 = this.props.dataSource.map(
            values => values.abbreviation
          );
          localStorage.setItem("Abbreviation", "");
          localStorage.setItem("Abbreviation", Abbr1);
        }

        this.setState(
          {
            selectedPropertyIdMultiple: values,
            selectedIDSet: IdSetArray,
            selectedPropertyAbbr: Abbr,
            selectAll: true
          },
          () => {
            localStorage.setItem("selectedPropertyIdMultipleNames", values);
            localStorage.setItem("selectedPropertyIdMultiple", IdSetArray);
            localStorage.setItem("Abbreviation", Abbr);
          }
        );
      }
    } else {
      values = removeDuplicates(values);
      values.forEach(element => {
        const obj = ComparisonData.find(x => element == x.name);
        if (obj != undefined) {
          NewSet.push(obj);
        }
      });

      IdSetArray = NewSet.map(values => values.propertyID);
      Abbr = NewSet.map(values => values.abbreviation);
      localStorage.setItem("Abbreviation", "");
      localStorage.setItem("Abbreviation", Abbr);
      //console.log(values, IdSetArray);
      this.setState({
        selectedPropertyIdMultiple: values,
        selectedIDSet: IdSetArray,
        selectedPropertyAbbr: Abbr,
        selectAll: false
      });
    }
  };

  /**
   * call for getting the report data
   */
  CallForGettingTheReportData = () => {
    this.props.onPropertySelect(
      this.state.selectedIDSet,
      this.state.selectedPropertyIdMultiple,
      this.state.selectedPropertyAbbr
    );
  };

  render() {
    return (
      <>
        {this.props.classTitle == "material" ? (
          <FormControl style={{ width: "200px" }}>
            <InputLabel id={"demo-simple-select-label"} style={{ width: "200px" }}>
              {"Data center list\r"}
            </InputLabel>
            <Select
              value={this.state.selectedPropertyId}
              onChange={e => this.setSingleSelect(e.target.value)}
            >
              {(this.props.dataSource || []).map((item, index) => (
                <MenuItem key={"dcList" + index} value={item.propertyID}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : this.props.SeType == "MultipleMaterial" ? (
          <FormControl>
            <InputLabel id={"demo-multiple-checkbox-label"} style={{ width: "200px" }}>
              {" "}
              {"Data center list\r"}
            </InputLabel>
            <Select
              labelId={"demo-multiple-checkbox-label"}
              id={"demo-multiple-checkbox"}
              multiple
              value={this.state.selectedPropertyIdMultiple}
              onChange={event => {
                this.handleOnDataCenterChange(event.target.value);
              }}
              onClose={this.CallForGettingTheReportData}
              input={<Input />}
              style={{ maxWidth: "300px", minWidth: "200px" }}
              renderValue={selected => selected.join(", ")}
            >
              <MenuItem value={"All"}>
                <Checkbox checked={this.state.selectAll} />
                <ListItemText primary={"Select All"} />
              </MenuItem>
              {(this.props.dataSource || []).map((data, ic) => (
                <MenuItem key={"masterOption" + ic} value={data.name}>
                  <Checkbox
                    checked={
                      this.state.selectedPropertyIdMultiple.indexOf(data.name) >
                      -1
                    }
                  />
                  <ListItemText primary={data.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Tooltip title={"Data center list"}>
            <select
              value={this.state.selectedPropertyId}
              onChange={e => this.props.onPropertySelect(e.target.value)}
              style={{
                padding: " 5px 10px 5px 10px ",
                border: " 1px solid #e5e5e5 "
              }}
            >
              {(this.props.dataSource || []).map((item, index) => (
                <option key={"dcList" + index} value={item.propertyID}>
                  {item.name}
                </option>
              ))}
            </select>
          </Tooltip>
        )}
      </>
    );
  }
}

export default DatacenterList;
